import React from 'react';
export function Footer() {
  return <footer className="bg-medical-blue text-white py-12 px-4 border-t border-blue-900 relative overflow-hidden" data-id="element-122">
      {/* Subtle watermark */}
      <div className="absolute -bottom-10 -right-10 text-9xl font-black text-white/5 pointer-events-none transform -rotate-12 select-none" data-id="element-123">
        @Mundodigitalarg
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-124">
        <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm font-medium mb-6 inline-block" data-id="element-125">
          mundodigitalarg.com
        </a>

        <h2 className="font-heading text-xl md:text-2xl font-bold mb-2" data-id="element-126">
          🩺 GUARDIA CLÍNICA · ATLAS VISUAL™
        </h2>

        <p className="text-blue-200 text-sm md:text-base mb-8" data-id="element-127">
          El atlas visual N°1 para estudiantes de medicina en Argentina.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-sm text-blue-300 mb-8" data-id="element-128">
          <a href="mailto:contacto@mundodigitalarg.com" className="hover:text-white transition-colors" data-id="element-129">
            contacto@mundodigitalarg.com
          </a>
          <span className="hidden md:inline" data-id="element-130">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-131">
            @mundodigitalarg
          </a>
        </div>

        <div className="text-xs text-blue-400/60 pt-8 border-t border-blue-800/50" data-id="element-132">
          © sistemapro.pro™ 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}